import { BRAND } from "../risikoanalyseStep/tokens";

const W = 140;
const H = 96;

const Wrap = ({ children }: { children: React.ReactNode }) => (
  <svg width={W} height={H} viewBox="0 0 140 96" fill="none">
    {children}
  </svg>
);

const Umsatz = () => (
  <Wrap>
    <rect x="14" y="60" width="14" height="22" fill={BRAND.pillarOrange} />
    <rect x="34" y="48" width="14" height="34" fill={BRAND.pillarOrange} opacity="0.8" />
    <rect x="54" y="34" width="14" height="48" fill={BRAND.pillarOrange} />
    <rect x="74" y="22" width="14" height="60" fill={BRAND.pillarOrange} opacity="0.85" />
    <rect x="94" y="14" width="14" height="68" fill={BRAND.pillarOrange} />
    <path d="M14 22l112-8" stroke={BRAND.gold} strokeWidth="2" strokeDasharray="4 3" />
  </Wrap>
);

const Wareneinsatz = () => (
  <Wrap>
    <rect x="22" y="28" width="44" height="44" rx="4" fill={BRAND.pillarBlue} />
    <path d="M22 40h44M44 28v44" stroke={BRAND.white} strokeWidth="2" opacity="0.7" />
    <rect x="78" y="38" width="40" height="34" rx="4" fill={BRAND.pillarBlue} opacity="0.7" />
    <path d="M78 50h40M98 38v34" stroke={BRAND.white} strokeWidth="1.5" opacity="0.7" />
  </Wrap>
);

const Rohertrag = () => (
  <Wrap>
    <circle cx="70" cy="48" r="34" fill={BRAND.pillarGreen} />
    <text x="70" y="56" fontFamily="Arial" fontSize="28" textAnchor="middle" fill={BRAND.white} fontWeight="700">€</text>
  </Wrap>
);

const Beschaeftigte = () => (
  <Wrap>
    <circle cx="44" cy="36" r="12" fill={BRAND.purple} />
    <path d="M28 72c0-9 7-16 16-16s16 7 16 16" fill={BRAND.purple} />
    <circle cx="86" cy="42" r="10" fill={BRAND.purple} opacity="0.75" />
    <path d="M72 72c0-7 6-12 14-12s14 5 14 12" fill={BRAND.purple} opacity="0.75" />
    <circle cx="116" cy="46" r="8" fill={BRAND.purple} opacity="0.55" />
  </Wrap>
);

// Geldschein + Kopf: die Sektion ist der Personalaufwand in Euro, nicht die
// Kopfzahl — ohne die Person daneben wäre sie von „Umsatz"/„Rohertrag" nicht zu
// unterscheiden, ohne den Schein nicht von „Beschäftigte".
const Bruttolohn = () => (
  <Wrap>
    <rect x="14" y="26" width="96" height="52" rx="5" fill={BRAND.pillarBlue} />
    <rect x="22" y="34" width="80" height="36" rx="3" fill="none" stroke={BRAND.white} strokeWidth="1.5" opacity="0.45" />
    <text x="62" y="61" fontFamily="Arial" fontSize="24" textAnchor="middle" fill={BRAND.white} fontWeight="700">€</text>
    <circle cx="108" cy="44" r="11" fill={BRAND.purple} />
    <path d="M92 78c0-9 7-16 16-16s16 7 16 16" fill={BRAND.purple} />
  </Wrap>
);

const Rendite = () => (
  <Wrap>
    <circle cx="70" cy="48" r="32" fill="none" stroke={BRAND.gold} strokeWidth="6" />
    <path d="M70 16a32 32 0 0 1 28 16" fill="none" stroke={BRAND.pillarGreen} strokeWidth="6" />
    <text x="70" y="56" fontFamily="Arial" fontSize="16" textAnchor="middle" fill={BRAND.ink} fontWeight="700">%</text>
  </Wrap>
);

const Eigenkapital = () => (
  <Wrap>
    <rect x="26" y="24" width="88" height="56" rx="4" fill={BRAND.pillarBlack} />
    <rect x="36" y="38" width="24" height="14" fill={BRAND.gold} />
    <rect x="36" y="58" width="68" height="6" fill={BRAND.white} opacity="0.4" />
    <rect x="36" y="68" width="40" height="6" fill={BRAND.white} opacity="0.4" />
  </Wrap>
);

const Liquiditaet = () => (
  <Wrap>
    <path d="M70 14c-18 18-28 30-28 44a28 28 0 0 0 56 0c0-14-10-26-28-44z" fill={BRAND.pillarBlue} />
    <ellipse cx="62" cy="52" rx="6" ry="3" fill={BRAND.white} opacity="0.6" />
  </Wrap>
);

const Verpflichtungen = () => (
  <Wrap>
    <rect x="20" y="14" width="80" height="68" rx="4" fill={BRAND.white} stroke={BRAND.pillarBlue} strokeWidth="2" />
    <path d="M28 26h64M28 38h64M28 50h64M28 62h44" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="110" cy="74" r="14" fill={BRAND.pillarOrange} />
    <text x="110" y="79" fontFamily="Arial" fontSize="16" textAnchor="middle" fill={BRAND.white} fontWeight="700">!</text>
  </Wrap>
);

const Buergschaften = () => (
  <Wrap>
    <path d="M70 14l32 12v22c0 18-14 32-32 38-18-6-32-20-32-38V26l32-12z" fill={BRAND.pillarGreen} />
    <path d="M58 50l8 8 16-16" stroke={BRAND.white} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </Wrap>
);

const StepHero = ({ id }: { id: string }) => {
  switch (id) {
    case "umsatz":
      return <Umsatz />;
    case "wareneinsatz":
      return <Wareneinsatz />;
    case "rohertrag":
      return <Rohertrag />;
    case "beschaeftigte":
      return <Beschaeftigte />;
    case "bruttolohn":
      return <Bruttolohn />;
    case "rendite":
      return <Rendite />;
    case "eigenkapital":
      return <Eigenkapital />;
    case "liquiditaet":
      return <Liquiditaet />;
    case "verpflichtungen":
      return <Verpflichtungen />;
    case "buergschaften":
      return <Buergschaften />;
    default:
      return <Umsatz />;
  }
};

export default StepHero;
